import type { Router } from '@tanstack/react-router'

let router: Router<any, 'never', true>

export const injectRouterToFetchInterceptors = (
  _router: Router<any, 'never', true>,
) => {
  router = _router
}

const { fetch: originalFetch } = window

const isNotAuthorized = (response: Response) => response.status === 401

const onBeforeRequest = (
  _resource: RequestInfo | URL,
  _config?: RequestInit,
) => {}

const onBeforeError = (response: Response) => {
  if (isNotAuthorized(response)) {
    const isAuthRoute = !!router.getMatch('/_auth')

    if (!isAuthRoute) {
      return response
    }

    const { location } = router.state

    router.navigate({
      to: '/login',
      state: {
        redirectTo: {
          pathname: location.pathname,
          search: location.searchStr,
        },
      },
    })
  }

  return response
}

// override the fetch function
window.fetch = async (...args) => {
  const [resource, config] = args

  onBeforeRequest(resource, config)

  try {
    const response = await originalFetch(resource, config)

    if (!response.ok) {
      onBeforeError(response)
    }

    return response
  } catch (error) {
    if (error instanceof Response) {
      onBeforeError(error)
    }

    throw error
  }
}
